export default __webpack_public_path__ + "static/FReg-Work-ee28683486fbfa1e4f8272b7483044f8.jpg";